import React from 'react';
import './NavBar.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGlobe } from '@fortawesome/free-solid-svg-icons';
import { faInstagram, faYoutube, faFacebookF } from '@fortawesome/free-brands-svg-icons';
import { faEnvelope } from '@fortawesome/free-regular-svg-icons';
import { useLocation, useNavigate } from 'react-router-dom';
import i18n from '../../languageConfig';

const LanguageAndSocialLinks = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const currentLanguage = i18n.language || 'en';

  const handleLanguageChange = (language) => {
    i18n.changeLanguage(language);
    localStorage.setItem('language', language);

    const currentPath = location.pathname;

    if (language === 'en') {
      if (!currentPath.startsWith('/en')) {
        navigate(`/en${currentPath.replace('/pt', '')}`);
      }
    } else if (language === 'pt') {
      if (!currentPath.startsWith('/pt')) {
        navigate(`/pt${currentPath.replace('/en', '')}`);
      }
    }
  };

  return (
    <div className="language-and-social-links">
      <div className="social-links">
        <a
          href="https://instagram.com/lambadacouncil/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <FontAwesomeIcon icon={faInstagram} />
        </a>
        <a
          href="https://www.facebook.com/profile.php?id=61565092723909"
          target="_blank"
          rel="noopener noreferrer"
        >
          <FontAwesomeIcon icon={faFacebookF} />
        </a>
        <a
          href="https://www.youtube.com/@LambadaWorldDanceCouncil"
          target="_blank"
          rel="noopener noreferrer"
        >
          <FontAwesomeIcon icon={faYoutube} />
        </a>
        <a href="mailto:lambadacouncil@gmail.com">
          <FontAwesomeIcon icon={faEnvelope} />
        </a>
      </div>
      <div className="languages">
        <FontAwesomeIcon icon={faGlobe} />
        <a
          onClick={() => handleLanguageChange('en')}
          className={`language-link ${currentLanguage === 'en' ? 'active-language' : ''}`}
        >
          ENGLISH
        </a>
        <p>|</p>
        <a
          onClick={() => handleLanguageChange('pt')}
          className={`language-link ${currentLanguage === 'pt' ? 'active-language' : ''}`}
        >
          PORTUGUÊS
        </a>
      </div>
    </div>
  );
};

export default LanguageAndSocialLinks;
